import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import { RegenerateProxiesModalComponent } from 'media/components/regenerateProxiesModal.component'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class GenerateProxyFilesOp extends BaseOperation {
  icon = 'far fa-retweet'
  showInSelectionToolbar = false
  showInSelectionOverflowMenu = true
  showInContextMenu = true
  showInAssetView = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = 1

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
    private ngbModal: NgbModal,
  ) {
    super()
    this.label = translate.instant('Generate proxy files')
  }

  isVisibleForDir (dir) {
    return this.mediaPermissions.getPermissionForFile(dir)?.allowWriteDb ?? false
  }

  isVisibleForBundle (bundle) {
    return bundle.mainfile && this.mediaPermissions.getPermissionForBundle(bundle)?.allowWriteDb
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present
  }

  async run ({ dirs, bundles }, options) {
    const bundleIds = bundles.filter(x => x.asset && x.mainfile?.present).map(x => x.id)
    const dirIds = dirs.filter(x => x.present).map(x => x.id)

    const m = this.ngbModal.open(RegenerateProxiesModalComponent)
    m.componentInstance.root = options.root
    m.componentInstance.options = {
      bundles: bundleIds,
      directories: dirIds,
      enqueueAtFront: true,
      force: false,
    }
    const assetTypes = new Set(bundles.map(x => x.asset?.type))
    if (assetTypes.size === 1) {
      m.componentInstance.type = [...assetTypes][0]
    }
    await m.result.catch(() => null)
  }
}

MediaOperationsService.register(GenerateProxyFilesOp)
